/**
 * Created by Ivan on 28.08.2025
 */

Reward.register("rave_reviews", {
    getIcon: function () {
        return bundles.reward_icons.frames.rave_reviews_png;
    },

    getCollectRewardEffect: function () {
        if (cleverapps.raveReviews.points >= cleverapps.raveReviews.calcGoal()) {
            return "rave_reviews.rupor.collected";
        }

        return "rave_reviews.rupor.collect";
    },

    receive: function (value) {
        cleverapps.raveReviews.addPoints(value, true);

        return function () {};
    }
});